import React from 'react';
import PropTypes from 'prop-types';
import { ReactDataTable } from '@metarouter-private/mr-mui';
import eventSchemaTableColumns from './eventSchemaTableColumns';
import NoDataText from 'app/components/data-table/NoDataText';

const PER_PAGE = 20;
const NO_DATA_MESSAGE = 'No event schemas found';
const ERROR_MESSAGE = 'Could not retrieve schema summary';

function EventSchemaTable({ loading, reports, reportsError, setSelectedReport, selectedReport }) {
  // TODO: bb - left as-is will convert to mui drawer in a separate MR
  const handleRowClicked = row => {
    const sameReport = (r1, r2) => {
      return r1 && r2 && r1.eventName === r2.eventName && r1.writekey === r2.writekey;
    };

    if (sameReport(selectedReport, row)) {
      setSelectedReport(null);
    } else {
      setSelectedReport(row);
    }
  };

  return (
    <ReactDataTable
      columns={eventSchemaTableColumns}
      loading={loading}
      paginationResetDefaultPage={loading}
      data={reports}
      noDataComponent={<NoDataText>{buildNoDataMessage(reportsError)}</NoDataText>}
      pagination
      paginationPerPage={PER_PAGE}
      highlightOnHover
      pointerOnHover
      keyField="eventName"
      onRowClicked={handleRowClicked}
      defaultSortFieldId="lastSeen"
      defaultSortAsc={false}
    />
  );
}

function buildNoDataMessage(reportsError) {
  return reportsError ? ERROR_MESSAGE : NO_DATA_MESSAGE;
}

const reportShape = {
  eventName: PropTypes.string,
  writekey: PropTypes.string,
  totalCount: PropTypes.string,
  combinations: PropTypes.string,
  lastSeen: PropTypes.object,
  lastSeenDate: PropTypes.string,
  earliestSeenDate: PropTypes.string,
  pipelineNames: PropTypes.string,
  pipelines: PropTypes.arrayOf(PropTypes.object),
};

EventSchemaTable.propTypes = {
  loading: PropTypes.bool.isRequired,
  reports: PropTypes.arrayOf(PropTypes.shape(reportShape)),
  reportsError: PropTypes.object,
  setSelectedReport: PropTypes.func.isRequired,
  selectedReport: PropTypes.shape(reportShape),
};

export default EventSchemaTable;
